import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import AcknowledgmentPopup from "../../../utils/AcknowledgmentPopup";
import api from "../../../api/axios";

const AttendanceApprovalForm = ({
  attendanceApprovalData,
  isModalOpen,
  setIsModalOpen,
}) => {
  let loginEmployeeId = localStorage.getItem("employeeID");

  const reasonType = [
    { value: 1, label: "Not in location issue" },
    { value: 2, label: "App not loading properly" },
    { value: 3, label: "Forgot to login in app" },
    { value: 4, label: "Forgot to logout from app" },
    { value: 5, label: "New Joinee Registration Process Not Completed" },
    { value: 6, label: "Weather-related delay" },
    { value: 7, label: "Public transport delays." },
    { value: 8, label: "Traffic congestion or road closure." },
    { value: 9, label: "Unexpected personal emergencies" },
    { value: 10, label: "Network outage." },
    { value: 11, label: "Other." },
  ];

  const acknowledgmentPopupData = {
    showAcknowledgmentPopup: false,
    popupVariant: "",
    popupMessage: "",
    popupIcon: "",
  };

  const [approvalForm, setApprovalForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState({
    show: false,
    message: "",
  });
  const [acknowledgmentPopup, setAcknowledgmentPopup] = useState(
    acknowledgmentPopupData
  );

  const navigate = useNavigate();
  const location = useLocation();

  console.log("attendanceApprovalData", attendanceApprovalData);

  const handleOnChange = (option, key) => {
    setApprovalForm((prev) => ({
      ...prev,
      [key]: option?.value || "",
    }));

    setErrors((prev) => ({
      ...prev,
      [key]: option?.value ? "" : `${key} is required`,
    }));
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };

  const hideAcknowledgmentPopup = () => {
    const resetAcknowledgmentPopupData = () => {
      setAcknowledgmentPopup(acknowledgmentPopupData);
      closeModal();
    };
    setTimeout(() => resetAcknowledgmentPopupData(), 2000);
  };

  // Detect edit mode
  const isEdit = Boolean(attendanceApprovalData?.approval_id);

  // Pre-fill form fields in edit mode
  useEffect(() => {
    if (isEdit) {
      setApprovalForm({
        reason: attendanceApprovalData?.approval_reason_id || "",
        message: attendanceApprovalData?.approval_message || "",
      });
    } else {
      setApprovalForm({});
    }
  }, [attendanceApprovalData, isEdit]);

  const applyForApproval = async () => {
    if (!approvalForm.reason || !approvalForm.message) {
      setErrors((prev) => ({
        ...prev,
        ["apply"]: `All fields are required`,
      }));
      return;
    } else {
      setErrors((prev) => ({
        ...prev,
        ["apply"]: "",
      }));
    }

    setLoading({
      show: true,
      message: isEdit ? "Updating approval..." : "Applying for approval...",
    });

    if (isEdit) {
      // Edit mode: PUT API
      api
        .put(`api/attendance/updateAttendanceApprovalForm`, {
          updated_by: loginEmployeeId,
          approval_id: attendanceApprovalData?.approval_id,
          reason: approvalForm.reason,
          message: approvalForm.message,
        })
        .then((res) => {
          setErrors({});
          if (res.data.success === true) {
            setAcknowledgmentPopup({
              showAcknowledgmentPopup: true,
              popupVariant: "success",
              popupMessage: "Successfully updated approval!",
              popupIcon: "fa-regular fa-circle-check",
            });
          }
        })
        .catch((err) => {
          setAcknowledgmentPopup({
            showAcknowledgmentPopup: true,
            popupVariant: "danger",
            popupMessage: "Something went wrong, Try again !",
            popupIcon: "fa-regular fa-circle-xmark",
          });
        })
        .finally(() => {
          hideAcknowledgmentPopup();
          setLoading({ show: false, message: "" });
        });
    } else {
      // Create mode: POST API
      api
        .post(`api/attendance/createAttendanceApproval`, {
          ...approvalForm,
          employee_id: attendanceApprovalData?.employeeId,
          attendance_id: attendanceApprovalData?.attendance_id,
          attendance_for_approval: attendanceApprovalData?.Date,
          status: "pending",
        })
        .then((res) => {
          setErrors({});
          if (res.data.success == true) {
            setAcknowledgmentPopup({
              showAcknowledgmentPopup: true,
              popupVariant: "success",
              popupMessage: "Successfully Applied for approval !",
              popupIcon: "fa-regular fa-circle-check",
            });
          }
        })
        .catch((err) => {
          if (err.response?.data?.error_code == "E01") {
            setErrors((prev) => ({
              ...prev,
              ["apply"]: err.response.data.message,
            }));
            setAcknowledgmentPopup({
              showAcknowledgmentPopup: true,
              popupVariant: "danger",
              popupMessage: "Something went wrong, Try again !",
              popupIcon: "fa-regular fa-circle-xmark",
            });
          }
        })
        .finally(() => {
          hideAcknowledgmentPopup();
          setLoading({ show: false, message: "" });
        });
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setApprovalForm({});
    setErrors({});
    navigate(`../${location.pathname}`);
  };

  return (
    <>
      <div
        id="add_leave"
        className={`modal custom-modal fade ${
          isModalOpen ? "show d-block" : ""
        }`}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Apply For Attendance Approval</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  closeModal();
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="input-block mb-3">
                  <label className="col-form-label fs-6">
                    For Date : {attendanceApprovalData?.Date}
                  </label>
                </div>
                <div className="input-block mb-3 d-flex gap-2 justify-content-between">
                  <label className="col-form-label fs-6">
                    Punch In At : {attendanceApprovalData?.PunchIn}
                  </label>
                  <label className="col-form-label fs-6">
                    Punch Out At : {attendanceApprovalData?.PunchOut}
                  </label>
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label fs-6">
                    Total hours : {attendanceApprovalData?.TotalHours}
                  </label>
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={reasonType}
                    value={
                      reasonType.find(
                        (option) => option.value === approvalForm?.reason
                      ) || null
                    }
                    placeholder="Select Reason"
                    styles={customStyles}
                    onChange={(option) => handleOnChange(option, "reason")}
                  />
                  {errors["reason"] && (
                    <p style={{ color: "red" }}>* {errors["reason"]}</p>
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Message <span className="text-danger">*</span>
                  </label>
                  <textarea
                    rows={4}
                    className="form-control"
                    defaultValue={approvalForm?.message || ""}
                    value={approvalForm?.message}
                    onChange={(e) => {
                      handleOnChange({ value: e.target.value }, "message");
                    }}
                  />
                  {errors["message"] && (
                    <p style={{ color: "red" }}>* {errors["message"]}</p>
                  )}
                </div>
                {errors["apply"] && (
                  <p style={{ color: "red" }}>* {errors["apply"]}</p>
                )}
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    onClick={() => applyForApproval()}
                    disabled={
                      !approvalForm.reason ||
                      !approvalForm?.message?.trim() ||
                      loading.show
                        ? true
                        : false
                    }
                  >
                    {isEdit ? "Update" : "Apply"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {loading.show && (
          <Loader show={loading.show} loadingMessage={loading.message} />
        )}
        {acknowledgmentPopup.showAcknowledgmentPopup ? (
          <AcknowledgmentPopup
            popupVariant={acknowledgmentPopup.popupVariant}
            popupMessage={acknowledgmentPopup.popupMessage}
            popupIcon={acknowledgmentPopup.popupIcon}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default AttendanceApprovalForm;
